import axios from "src/api/axiosInstance";

const postLogin = (username, password) => {
  return axios.post(
    '/token/login',
    JSON.stringify({
      username: username,
      password: password
    }),
    {
      transformRequest: (data, headers) => {
        if (headers.Authorization) {
          delete headers.Authorization;
        }

        return data;
      }
    }
  )
}

const postRefreshToken = (refreshToken) => {
  return axios.post(
    '/token/refresh',
    JSON.stringify({
      refresh_token: refreshToken
    })
  );
}

export {
  postLogin,
  postRefreshToken
};